import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col" }
const _hoisted_3 = { class: "col-5" }
const _hoisted_4 = { class: "d-flex align-items-center justify-content-end sort-category" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", {
  for: "select-category-id",
  class: "me-2 d-none d-sm-block"
}, "Kategorier", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("option", { value: "-1" }, "Start", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("optgroup", { label: "Kategorier" }, null, -1)
const _hoisted_8 = ["value"]
const _hoisted_9 = { class: "row" }
const _hoisted_10 = {
  key: 0,
  class: "d-none d-md-block col-md-2"
}
const _hoisted_11 = ["srcset"]
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "col-12 col-md-10" }
const _hoisted_14 = { class: "fw-bolder mb-4" }
const _hoisted_15 = {
  key: 0,
  class: "lead"
}
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = ["onClick"]
const _hoisted_18 = {
  key: 0,
  class: "row"
}
const _hoisted_19 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex align-items-center mb-4\"><div class=\"placeholder me-2\" style=\"height:50px;\"><h5>Model för artikel</h5></div><span class=\"placeholder me-1\" style=\"width:50px;height:50px;\"></span><span class=\"placeholder me-1\" style=\"width:50px;height:50px;\"></span><span class=\"placeholder me-1\" style=\"width:50px;height:50px;\"></span></div>", 1)
const _hoisted_20 = { class: "row gx-4 gx-lg-5 row-cols-1 row-cols-md-2 row-cols-xl-3 row-cols-xxl-4" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", {
  class: "card shadow h-100",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "bd-placeholder-img card-img-top",
    width: "100%",
    height: "180",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-label": "Placeholder",
    preserveAspectRatio: "xMidYMid slice",
    focusable: "false"
  }, [
    /*#__PURE__*/_createElementVNode("title", null, "Placeholder"),
    /*#__PURE__*/_createElementVNode("rect", {
      width: "465",
      height: "390",
      fill: "#8d8f91"
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "card-body p-4 text-center" }, [
    /*#__PURE__*/_createElementVNode("h4", { class: "card-title placeholder-glow" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "placeholder col-6 p-3" })
    ]),
    /*#__PURE__*/_createElementVNode("span", { class: "placeholder col-5 p-1" })
  ])
], -1)
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = { class: "d-flex align-items-center" }
const _hoisted_24 = { class: "mb-4" }
const _hoisted_25 = { class: "row gx-4 gx-lg-5 row-cols-1 row-cols-md-2 row-cols-xl-3 row-cols-xxl-4" }
const _hoisted_26 = {
  key: 2,
  class: "row border-top pt-5"
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("h3", null, "Några tidigare projekt", -1)
const _hoisted_28 = { class: "row gx-4 gx-lg-5 row-cols-1 row-cols-md-2 row-cols-xl-3 row-cols-xxl-4" }
const _hoisted_29 = { class: "mt-5 border-top border-3 pt-5" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("h4", { class: "text-center display-6" }, "Utforska mer", -1)

import { useRoute, useRouter } from 'vue-router';
    import { onMounted, ref, computed, watch } from 'vue';
    import { articleApi } from '@/services/article.service';
    import { ArticleViewModel } from '@/types/ArticleViewModel';
    import { CategoryViewModel } from '@/types/CategoryViewModel';
    import ArticleCard from '@/components/ArticleCard.vue';
    import Breadcrumbs from '@/components/Breadcrumbs.vue';
    import Categories from '@/components/Categories.vue';
    import SuitsFor from '@/components/SuitsFor.vue';
    import { useMeta } from '@/composables/meta';
    import { useCanonical } from '@/composables/canonical';

    import { useRootStore } from '@/store/root.store';
    
export default /*#__PURE__*/_defineComponent({
  __name: 'Articles',
  props: {
    categoryId: null
  },
  setup(__props: any) {

const props = __props as { categoryId: number }

    const rootStore = useRootStore();
    const route = useRoute();
    const router = useRouter();

    
    const selectedCategoryId = ref<number>(props.categoryId);

    const breadcrumbs = computed(() => {
        return [
            { name: selectedCategory.value?.name, path: selectedCategory.value?.urlSlug, active: true }
        ]
    });

    function getSuitsFor(articleGroup: ArticleViewModel[]) {
        return removeDuplicates(articleGroup.flatMap(article => article.suitsFor));
    }

    function removeDuplicates(arr: any[]) {
        const uniqueArr: any[] = [];
        const ids: any[] = [];

        for (const item of arr) {
            if (!ids.includes(item.suitsForId)) {
                uniqueArr.push(item);
                ids.push(item.suitsForId);
            }
        }

        return uniqueArr;
    }

    const selectedCategory = computed(() => {
        return rootStore.categories.length
            ? rootStore.categories.find(x => x.id === selectedCategoryId.value)
            : {} as CategoryViewModel;
    });

    function groupBy<T>(list: T[], property: keyof T) {
        const groupedObjects: { [key: string]: T[] } = {};

        list.forEach(object => {
            const key = String(object[property]);

            if (!groupedObjects[key]) {
                groupedObjects[key] = [];
            }

            groupedObjects[key].push(object);
        });

        return groupedObjects;
    }

    watch(selectedCategoryId, (after, before) => {
        setMeta();
        useCanonical(selectedCategory.value?.urlSlug ?? '/');
    });

    watch(() => route.path, (newPath, oldPath) => {
        if (newPath !== oldPath) {
            const category = rootStore.categories.find(x => x.urlSlug === newPath.slice(1, newPath.length));
            if (category)
                selectedCategoryId.value = category.id;
        }
    });

    function onCategoryChanged() {
        if (Number(selectedCategoryId.value) === -1)
            router.push({ name: 'Start' });
        else {
            const urlSlug = selectedCategory.value?.urlSlug ?? '/';
            router.replace({ path: urlSlug });
        }
    }

    const filteredArticlesBySelectedCategory = computed(() => {
        if (rootStore.articles.length && selectedCategory.value?.id) {
            let filteredArticles = rootStore.articles.filter(x => x.categoryId === selectedCategory.value?.id);
            if (selectedCategory.value.id !== 2)
                filteredArticles = filteredArticles.filter(x => !x.isSold);

            return groupBy(filteredArticles, 'modelName');
        }

        return {};
    });

    const soldArticles = computed(() => {
        if (rootStore.articles.length && selectedCategory.value?.id) {
            const filteredArticles = rootStore.articles.filter(x => x.categoryId === selectedCategory.value?.id && x.isSold);
            return filteredArticles;
        }

        return {};
    });

    function setMeta() {
        useMeta(selectedCategory.value?.metaTitle ?? '', selectedCategory.value?.metaDescription ?? '');
    }

    onMounted(async () => {
        setMeta();
        useCanonical(selectedCategory.value?.urlSlug ?? '/');
        rootStore.setArticles(await articleApi.getAllActive());
    });

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", null, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(Breadcrumbs, { items: _unref(breadcrumbs) }, null, 8, ["items"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _withDirectives(_createElementVNode("select", {
              id: "select-category-id",
              class: "form-select",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedCategoryId).value = $event)),
              style: {"width":"120px"},
              onChange: onCategoryChanged
            }, [
              _hoisted_6,
              _hoisted_7,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(rootStore).categories, (category) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: category.id,
                  value: category.id
                }, _toDisplayString(category.name), 9, _hoisted_8))
              }), 128))
            ], 544), [
              [_vModelSelect, selectedCategoryId.value]
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        (_unref(selectedCategory).id !== 2)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("picture", null, [
                _createElementVNode("source", {
                  srcset: `/images/${_unref(selectedCategory).file.name}.webp`,
                  type: "image/webp"
                }, null, 8, _hoisted_11),
                _createElementVNode("img", {
                  src: `/images/${_unref(selectedCategory).file.name}.png`,
                  class: "img-fluid rounded"
                }, null, 8, _hoisted_12)
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("h1", _hoisted_14, _toDisplayString(_unref(selectedCategory).name), 1),
          (_unref(selectedCategory).listDescription)
            ? (_openBlock(), _createElementBlock("p", _hoisted_15, [
                _createElementVNode("span", {
                  innerHTML: _unref(selectedCategory).listDescription
                }, null, 8, _hoisted_16),
                _createTextVNode(),
                _createVNode(_component_router_link, {
                  to: { name: 'ContactUs' },
                  custom: ""
                }, {
                  default: _withCtx(({ navigate }) => [
                    _createElementVNode("button", {
                      type: "submit",
                      class: "btn btn-primary d-block ms-auto mt-3",
                      onClick: navigate
                    }, " KONTAKTA OSS ", 8, _hoisted_17)
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      (!_unref(rootStore).hasLoadedArticles)
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
            _hoisted_19,
            _createElementVNode("div", _hoisted_20, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_unref(selectedCategory).id === 2 ? 8 : 1), (index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "col mb-5",
                  key: index
                }, _hoisted_22))
              }), 128))
            ])
          ]))
        : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_unref(filteredArticlesBySelectedCategory), (articlesGroup, groupKey) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "row",
              key: groupKey
            }, [
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("h2", _hoisted_24, _toDisplayString(groupKey), 1),
                _createVNode(SuitsFor, {
                  items: getSuitsFor(articlesGroup),
                  showHeader: false,
                  iconClasses: 'extra-small d-inline-block mb-3 ms-2'
                }, null, 8, ["items"])
              ]),
              _createElementVNode("div", _hoisted_25, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(articlesGroup, (article) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "col mb-5 cursor-pointer",
                    key: article.id
                  }, [
                    _createVNode(ArticleCard, {
                      article: article,
                      heightClass: 'h-100'
                    }, null, 8, ["article"])
                  ]))
                }), 128))
              ])
            ]))
          }), 128)),
      (_unref(selectedCategory).id !== 2 && _unref(soldArticles).length && !_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
            _hoisted_27,
            _createElementVNode("div", _hoisted_28, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(soldArticles), (article) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "col mb-5 cursor-pointer mt-4",
                  key: article.id
                }, [
                  _createVNode(ArticleCard, {
                    article: article,
                    heightClass: 'h-100'
                  }, null, 8, ["article"])
                ]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("section", _hoisted_29, [
      _hoisted_30,
      _createVNode(Categories, {
        excludeIds: [selectedCategoryId.value]
      }, null, 8, ["excludeIds"])
    ])
  ], 64))
}
}

})